import { Component } from '@angular/core';
import { ParagraphComponent } from '@spartacus/storefront';

@Component({
    selector: 'app-uig-paragraph',
    templateUrl: './uig-paragraph.component.html',
    styleUrls: ['./uig-paragraph.component.scss'],
    standalone: false
})
export class UigParagraphComponent extends ParagraphComponent {
  
}
